import {
  GET_API,
  POST_API,
  PUT_API,
  DELETE_API,
  PATCH_API,
} from "../../Functionalities/APIs";
import { appendImages } from "../../Functionalities/Functions";

export const ManageItemVariant = async (e, keyword, data, params) => {
  let path = "/items/itemvarients/";

  if (keyword == "add") {
    var bodyFormData = new FormData();
    bodyFormData.append("name", data.name);
    bodyFormData.append("item_id", data.item_id);
    bodyFormData.append("rate", data.rate);
    bodyFormData.append("offer_rate", data.offer_rate);
    bodyFormData.append("offer_enabled", data.offer_enabled);
    bodyFormData.append("mrp", data.mrp);
    bodyFormData.append("description", data.description);
    bodyFormData.append("dual_description", data.dual_description);
    bodyFormData.append("food_type", data.type || data.food_type || "");
    bodyFormData.append("order_limit", data.order_limit);
    bodyFormData.append("commission_rate", data?.commission_rate);

    let result = POST_API(bodyFormData, "", path);

    return await result.then((result) => {
      // void 0
      if (result) {
        // void 0
        //shabeeb change start
        return result;
        //shabeeb change end
      } else {
        return 0;
      }
    });
  }

  if (keyword == "patch") {
    var fdata = new FormData();

    fdata.append("name", data.name);

    let result = POST_API(fdata, "", path);

    return await result.then((result) => {
      // void 0
      if (result) {
        // void 0
        return result.status;
      } else {
        return 0;
      }
    });
  }
  if (keyword == "update") {
    // void 0
    var fdata = new FormData();
    fdata.append("item_id", data.item);
    fdata.append("magnitude", "");
    fdata.append("mrp", data.rate);
    fdata.append("name", data.name);
    fdata.append("food_type", data.type || data.food_type || "");
    fdata.append("order_limit", data.order_limit);
    fdata.append("offer_rate", data.offer_rate);
    fdata.append("offer_enabled", data.offer_enabled);
    fdata.append("commission_rate", data?.commission_rate);

    // fdata.append('name', 'full');
    fdata.append("rate", data.rate);
    fdata.append("id", data.id);

    let result = PUT_API(fdata, "", path);

    return await result.then((result) => {
      // void 0
      if (result) {
        // void 0
        return result;
      } else {
        return 0;
      }
    });
  }
  if (keyword == "delete") {
    //shabeeb change start
    //alert("delete worked " + params)

    let result = DELETE_API("", params, path);
    //alert("delete worked")
    //shabeeb change end

    return await result.then((result) => {
      // void 0
      if (result) {
        // void 0
        return result;
      } else {
        return 0;
      }
    });
  }
  if (keyword == "get") {
    let result = GET_API("", params, path);
    // void 0

    return await result.then((result) => {
      // void 0
      if (result) {
        // void 0
        return result;
      } else {
        return 0;
      }
    });
  }
};

export const ManageStatus = async (e, keyword, data, params) => {
  let path = "/order/status/";
  params = "";

  if (keyword == "add") {
    // alert("Add worked")
    var fdata = new FormData();

    fdata.append("name", data.name);

    let result = POST_API(fdata, "", path);

    return await result.then((result) => {
      // void 0
      if (result) {
        // void 0
        return result.status;
      } else {
        return 0;
      }
    });
  }
  if (keyword == "patch") {
    // alert("Add worked")
    var fdata = new FormData();

    fdata.append("name", data.name);

    let result = POST_API(fdata, "", path);

    return await result.then((result) => {
      // void 0
      if (result) {
        // void 0
        return result.status;
      } else {
        return 0;
      }
    });
  }
  if (keyword == "update") {
    var fdata = new FormData();
    fdata.append("id", data.id);
    fdata.append("name", data.name);

    let result = PUT_API(fdata, "", path);
    // void 0
    // return 0
    return await result.then((result) => {
      // void 0
      if (result) {
        // void 0
        return result.status;
      } else {
        return 0;
      }
    });
  }
  if (keyword == "delete") {
    // alert("delete worked")

    let result = DELETE_API("", params, path);
    // void 0

    return await result.then((result) => {
      // void 0
      if (result) {
        // void 0
        return result;
      } else {
        return 0;
      }
    });
  }
  if (keyword == "get") {
    let result = GET_API("", params, path);
    // void 0

    return await result.then((result) => {
      // void 0
      if (result) {
        // void 0
        return result;
      } else {
        return 0;
      }
    });
  }
};

export const ManageVariantImage = async (e, keyword, data, params) => {
  let path = "/items/details/";

  if (keyword == "add") {
    // alert("Add worked")
    // return 0
    var bodyFormData = new FormData();
    // bodyFormData.append('item_id', data.item_id);
    bodyFormData.append("keyword", data.keyword);
    bodyFormData.append("item_id", data.item_id);

    appendImages(bodyFormData, data.images);

    let result = POST_API(bodyFormData, "", path);

    return await result.then((result) => {
      // void 0
      if (result) {
        // void 0
        return result.status;
      } else {
        return 0;
      }
    });
  }

  if (keyword == "patch") {
    // alert("patch worked")
    var fdata = new FormData();

    if (data.keyword == "remove_images") {
      fdata.append("image_ids", JSON.stringify([data.image_ids]));
    } else if (data.keyword == "add_images") {
      appendImages(fdata, data.images);
    } else {
      // alert("Something went wrong")
    }
    fdata.append("item_id", data.item_id);
    fdata.append("keyword", data.keyword);

    // for (var pair of fdata.entries()) {
    //     void 0
    // }

    let result = PATCH_API(fdata, "", path);

    return result.then((result) => {
      // void 0
      if (result) {
        // void 0
        return result;
      } else {
        return 0;
      }
    });
  }
  if (keyword == "update") {
    var fdata = new FormData();
    fdata.append("id", data.id);
    fdata.append("name", data.name);

    let result = PUT_API(fdata, "", path);
    // void 0
    // return 0
    return await result.then((result) => {
      // void 0
      if (result) {
        // void 0
        return result.status;
      } else {
        return 0;
      }
    });
  }
  if (keyword == "delete") {
    // alert("delete worked " + params)

    let result = DELETE_API("", params, path);
    // alert("delete worked")

    return await result.then((result) => {
      // void 0
      if (result) {
        // void 0
        return result;
      } else {
        return 0;
      }
    });
  }
  if (keyword == "get") {
    let result = GET_API("", params, path);
    // void 0

    return await result.then((result) => {
      // void 0
      if (result) {
        // void 0
        return result;
      } else {
        return 0;
      }
    });
  }
};

export const ManageTags = async (e, keyword, data, params) => {
  let path = "/items/details/";
  if (keyword == "patch") {
    var fdata = new FormData();
    if (data[0].keyword == "add_category_tag") {
      fdata.append("keyword", "add_category_tag");
    }
    if (data[0].keyword == "remove_category_tag") {
      fdata.append("keyword", "remove_category_tag");
    }
    // void 0
    // void 0
    // void 0

    fdata.append("item_id", data[2].id);
    fdata.append("category_tag", JSON.stringify(data[1].list));

    let result = PATCH_API(fdata, "", path);

    return result.then((result) => {
      // void 0
      if (result) {
        // void 0
        return result;
      } else {
        return 0;
      }
    });
  }
};
export const ManageInnerCat = async (e, keyword, data, params) => {
  let path = "/items/details/";
  if (keyword == "patch") {
    var fdata = new FormData();
    if (data[0].keyword == "add_inner_cat_product") {
      fdata.append("keyword", "add_inner_cat_product");
      fdata.append("item_id", data[2].id);

      fdata.append("inner_category_id", data[1].list);
    }
    if (data[0].keyword == "remove_inner_cat_product") {
      fdata.append("keyword", "remove_inner_cat_product");
      fdata.append("inner_category_id", data[1].list);
      fdata.append("item_id", data[2].id);
    }

    let result = PATCH_API(fdata, "", path);

    return result.then((result) => {
      // void 0
      if (result) {
        // void 0
        return result;
      } else {
        return 0;
      }
    });
  }
};
